import sideBar6 from '../assets/utils/images/sidebar/city1.jpg';

export const SET_ENABLE_BACKGROUND_IMAGE = 'THEME_OPTIONS/SET_ENABLE_BACKGROUND_IMAGE';

export const SET_ENABLE_MOBILE_MENU = 'THEME_OPTIONS/SET_ENABLE_MOBILE_MENU';
export const SET_ENABLE_MOBILE_MENU_SMALL = 'THEME_OPTIONS/SET_ENABLE_MOBILE_MENU_SMALL';

export const SET_ENABLE_FIXED_HEADER = 'THEME_OPTIONS/SET_ENABLE_FIXED_HEADER';
export const SET_ENABLE_HEADER_SHADOW = 'THEME_OPTIONS/SET_ENABLE_HEADER_SHADOW';
export const SET_ENABLE_SIDEBAR_SHADOW = 'THEME_OPTIONS/SET_ENABLE_SIDEBAR_SHADOW';
export const SET_ENABLE_FIXED_SIDEBAR = 'THEME_OPTIONS/SET_ENABLE_FIXED_SIDEBAR';
export const SET_ENABLE_CLOSED_SIDEBAR = 'THEME_OPTIONS/SET_ENABLE_CLOSED_SIDEBAR';
export const SET_ENABLE_FIXED_FOOTER = 'THEME_OPTIONS/SET_ENABLE_FIXED_FOOTER';

export const SET_ENABLE_PAGETITLE_ICON = 'THEME_OPTIONS/SET_ENABLE_PAGETITLE_ICON';
export const SET_ENABLE_PAGETITLE_SUBHEADING = 'THEME_OPTIONS/SET_ENABLE_PAGETITLE_SUBHEADING';
export const SET_ENABLE_PAGE_TABS_ALT = 'THEME_OPTIONS/SET_ENABLE_PAGE_TABS_ALT';

export const SET_BACKGROUND_IMAGE = 'THEME_OPTIONS/SET_BACKGROUND_IMAGE';
export const SET_BACKGROUND_COLOR = 'THEME_OPTIONS/SET_BACKGROUND_COLOR';
export const SET_COLOR_SCHEME = 'THEME_OPTIONS/SET_COLOR_SCHEME';
export const SET_BACKGROUND_IMAGE_OPACITY = 'THEME_OPTIONS/SET_BACKGROUND_IMAGE_OPACITY';

export const SET_HEADER_BACKGROUND_COLOR = 'THEME_OPTIONS/SET_HEADER_BACKGROUND_COLOR';

const STORAGE_KEY = 'adstraffic.themeOptions';

const defaultState = {
    backgroundColor: '',
    headerBackgroundColor: '',
    enableMobileMenuSmall: '',
    enableBackgroundImage: false,
    enableClosedSidebar: false,
    enableFixedHeader: true,
    enableHeaderShadow: true,
    enableSidebarShadow: true,
    enableFixedFooter: true,
    enableFixedSidebar: true,
    colorScheme: 'white',
    backgroundImage: sideBar6,
    backgroundImageOpacity: 'opacity-06',
    enablePageTitleIcon: true,
    enablePageTitleSubheading: true,
    enablePageTabsAlt: true,
};

const persistableKeys = [
    'backgroundColor',
    'headerBackgroundColor',
    'enableBackgroundImage',
    'enableClosedSidebar',
    'enableFixedHeader',
    'enableHeaderShadow',
    'enableSidebarShadow',
    'enableFixedFooter',
    'enableFixedSidebar',
    'colorScheme',
    'backgroundImage',
    'backgroundImageOpacity',
    'enablePageTitleIcon',
    'enablePageTitleSubheading',
    'enablePageTabsAlt',
];

const loadPersistedState = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return {};
    }

    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return {};
        }

        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
            return {};
        }

        return persistableKeys.reduce((acc, key) => {
            if (Object.prototype.hasOwnProperty.call(parsed, key)) {
                acc[key] = parsed[key];
            }
            return acc;
        }, {});
    } catch (error) {
        console.error('Error loading theme options:', error);
        return {};
    }
};

const persistState = (state) => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return;
    }

    try {
        const payload = persistableKeys.reduce((acc, key) => {
            acc[key] = state[key];
            return acc;
        }, {});
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {
        console.error('Error saving theme options:', error);
    }
};

const initialState = {
    ...defaultState,
    ...loadPersistedState(),
};

export const setEnableBackgroundImage = enableBackgroundImage => ({
    type: SET_ENABLE_BACKGROUND_IMAGE,
    enableBackgroundImage
});

export const setEnableFixedHeader = enableFixedHeader => ({
    type: SET_ENABLE_FIXED_HEADER,
    enableFixedHeader
});

export const setEnableHeaderShadow = enableHeaderShadow => ({
    type: SET_ENABLE_HEADER_SHADOW,
    enableHeaderShadow
});

export const setEnableSidebarShadow = enableSidebarShadow => ({
    type: SET_ENABLE_SIDEBAR_SHADOW,
    enableSidebarShadow
});

export const setEnablePageTitleIcon = enablePageTitleIcon => ({
    type: SET_ENABLE_PAGETITLE_ICON,
    enablePageTitleIcon
});

export const setEnablePageTitleSubheading = enablePageTitleSubheading => ({
    type: SET_ENABLE_PAGETITLE_SUBHEADING,
    enablePageTitleSubheading
});

export const setEnablePageTabsAlt = enablePageTabsAlt => ({
    type: SET_ENABLE_PAGE_TABS_ALT,
    enablePageTabsAlt
});

export const setEnableFixedSidebar = enableFixedSidebar => ({
    type: SET_ENABLE_FIXED_SIDEBAR,
    enableFixedSidebar
});

export const setEnableClosedSidebar = enableClosedSidebar => ({
    type: SET_ENABLE_CLOSED_SIDEBAR,
    enableClosedSidebar
});

export const setEnableMobileMenu = enableMobileMenu => ({
    type: SET_ENABLE_MOBILE_MENU,
    enableMobileMenu
});

export const setEnableMobileMenuSmall = enableMobileMenuSmall => ({
    type: SET_ENABLE_MOBILE_MENU_SMALL,
    enableMobileMenuSmall
});

export const setEnableFixedFooter = enableFixedFooter => ({
    type: SET_ENABLE_FIXED_FOOTER,
    enableFixedFooter
});

export const setBackgroundColor = backgroundColor => ({
    type: SET_BACKGROUND_COLOR,
    backgroundColor
});

export const setHeaderBackgroundColor = headerBackgroundColor => ({
    type: SET_HEADER_BACKGROUND_COLOR,
    headerBackgroundColor
});

export const setColorScheme = colorScheme => ({
    type: SET_COLOR_SCHEME,
    colorScheme
});

export const setBackgroundImageOpacity = backgroundImageOpacity => ({
    type: SET_BACKGROUND_IMAGE_OPACITY,
    backgroundImageOpacity
});

export const setBackgroundImage = backgroundImage  => ({
    type: SET_BACKGROUND_IMAGE,
    backgroundImage
});

export default function reducer(state = initialState, action) {
    let nextState = state;

    switch (action.type) {
        case SET_ENABLE_BACKGROUND_IMAGE:
            nextState = {
                ...state,
                enableBackgroundImage: action.enableBackgroundImage
            };
            break;

        case SET_ENABLE_FIXED_HEADER:
            nextState = {
                ...state,
                enableFixedHeader: action.enableFixedHeader
            };
            break;

        case SET_ENABLE_HEADER_SHADOW:
            nextState = {
                ...state,
                enableHeaderShadow: action.enableHeaderShadow
            };
            break;

        case SET_ENABLE_SIDEBAR_SHADOW:
            nextState = {
                ...state,
                enableSidebarShadow: action.enableSidebarShadow
            };
            break;

        case SET_ENABLE_PAGETITLE_ICON:
            nextState = {
                ...state,
                enablePageTitleIcon: action.enablePageTitleIcon
            };
            break;

        case SET_ENABLE_PAGETITLE_SUBHEADING:
            nextState = {
                ...state,
                enablePageTitleSubheading: action.enablePageTitleSubheading
            };
            break;

        case SET_ENABLE_PAGE_TABS_ALT:
            nextState = {
                ...state,
                enablePageTabsAlt: action.enablePageTabsAlt
            };
            break;

        case SET_ENABLE_FIXED_SIDEBAR:
            nextState = {
                ...state,
                enableFixedSidebar: action.enableFixedSidebar
            };
            break;

        case SET_ENABLE_MOBILE_MENU:
            return {
                ...state,
                enableMobileMenu: action.enableMobileMenu
            };

        case SET_ENABLE_MOBILE_MENU_SMALL:
            return {
                ...state,
                enableMobileMenuSmall: action.enableMobileMenuSmall
            };

        case SET_ENABLE_CLOSED_SIDEBAR:
            nextState = {
                ...state,
                enableClosedSidebar: action.enableClosedSidebar
            };
            break;

        case SET_ENABLE_FIXED_FOOTER:
            nextState = {
                ...state,
                enableFixedFooter: action.enableFixedFooter
            };
            break;

        case SET_BACKGROUND_COLOR:
            nextState = {
                ...state,
                backgroundColor: action.backgroundColor
            };
            break;

        case SET_HEADER_BACKGROUND_COLOR:
            nextState = {
                ...state,
                headerBackgroundColor: action.headerBackgroundColor
            };
            break;

        case SET_COLOR_SCHEME:
            nextState = {
                ...state,
                colorScheme: action.colorScheme
            };
            break;

        case SET_BACKGROUND_IMAGE:
            nextState = {
                ...state,
                backgroundImage: action.backgroundImage
            };
            break;

        case SET_BACKGROUND_IMAGE_OPACITY:
            nextState = {
                ...state,
                backgroundImageOpacity: action.backgroundImageOpacity
            };
            break;

        default:
            return state;
    }

    if (nextState !== state) {
        persistState(nextState);
    }

    return nextState;
}
